// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__18ALu","fillColor":"IconSuccess_fillColor__lN0x-"};